<app-navigation-menu
  [menuDataUrl]="menuDataUrl"
  [postFavouritesUrl]="saveFavouritesUrl"
  [userName]="personName"
  [pictureUrl]="pictureUrl"
  [logoutUrl]="logoutUrl"
  [myProfileUrl]="myProfileUrl"
  [activeMenuItem]="activeMenuItem"
></app-navigation-menu>

<div class="container">
  <router-outlet></router-outlet>
</div>
